<template>
  <div>
    <Panel>
      <template v-slot:header>
        <span data-cy="heading">Account Summary</span>
      </template>

      <template v-slot:content>
        <div class="w-50">
          <b-card-group deck>
            <b-card 
              bg-variant="success" 
              text-variant="white" 
              class="text-center"
            >
              <template #header>
                <span style="color: #00ff61;">
                  <font-awesome-icon 
                    v-b-tooltip.hover 
                    title="Your total account balance"
                    :icon="['fas', 'dollar-sign']" 
                  />
                </span> Available Balance
              </template>
              <b-card-text> {{ formatCurrency(accountSummary.cashBalance) }} </b-card-text>
            </b-card>
            <b-card 
              v-if="!isBuyerAccount" 
              bg-variant="primary" 
              text-variant="white" 
              class="text-center"
            >
              <template #header>
                <span style="color: #00cdff;">
                  <font-awesome-icon 
                    v-b-tooltip.hover 
                    title="Your estimated future payouts"
                    :icon="['fas', 'hand-holding-usd']" 
                  />
                </span> Pending Payments
              </template>
              <b-card-text> {{ formatCurrency(sellerPendingBalance) }} </b-card-text>
            </b-card>
          </b-card-group>
        </div>
      </template>
    </Panel>

    <CreditCardCharges
      v-if="showCreditCardCharges"
    />

    <Invoices v-if="!isBuyerAccount || !accountDetails.billingConfiguration.prePay" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import formatCurrency from '@/utils/formatCurrency'
import CreditCardCharges from '../buyer/CreditCardCharges.vue'
import Invoices from '../billing/Invoices.vue'

export default {
  name: 'MyAccount',

  title: 'My Account',

  components: {
    CreditCardCharges,
    Invoices,
  },

  data() {

    return {
      loading: false,
      details: {}
    }
  },
  computed: {
    ...mapState('billing', ['accountSummary']),
    ...mapState('dashboard', ['chargeReceipts', 'creditCardChargesFetched']),
    ...mapGetters('auth', ['isBuyerAccount', 'accountDetails']),
    ...mapGetters('billing', ['sellerPendingBalance']),
    showCreditCardCharges() {
      if (!this.isBuyerAccount) {
        return false
      }
      const isPrePay = this.accountDetails?.billingConfiguration?.prePay
      // Pre-pay buyers always see credit card charges
      if (isPrePay) {
        return true
      }
      // Post-paid buyers only see credit card charges if they have any
      // Wait for the fetch to complete before deciding to avoid race condition
      return this.creditCardChargesFetched && this.chargeReceipts && this.chargeReceipts.length > 0
    },
  },
  async created() {
    await this.getAccountBillingSummary()
    if (this.isBuyerAccount) {
      await this.getCreditCardCharges()
    }
  },
  methods: {
    ...mapActions('billing', ['getAccountBillingSummary']),
    ...mapActions('dashboard', ['getCreditCardCharges']),
    formatCurrency,

  }
}
</script>

<style lang="scss" scoped>
</style>
